/*
 * slideToggle/index.js
 */

export default class SlideToggle {
    constructor (el, action = false) {
        this.el = el
        this.action = action
        this.init()
    }

    init () {
        this.target = document.getElementById(this.el.dataset.accordionToggle)
        this.computedStyles = window.getComputedStyle(this.target)
        this.animationDuration = parseFloat(this.computedStyles.transitionDuration)
        this.animationDurationMs = this.animationDuration * 1000
        this.currentDisplay = this.computedStyles.display
        this.heightTarget = null
        this.delay = 100

        if (this.animationDuration === 0) {
            console.warn('slideToggle use only CSS Transition to animate the height, the target does not have')
        }

        this.target.style.overflow = 'hidden'

        if (this.currentDisplay === 'none' && (this.action === 'open' || this.action === false)) {
            this.open()
        } else if ((this.currentDisplay === '' || this.currentDisplay === 'block') && (this.action === 'close' || this.action === false)) {
            this.close()
        }
    }

    open () {
        this.target.style.height = 'auto'
        this.target.style.display = 'block'
        this.heightTarget = this.target.offsetHeight
        this.el.setAttribute('data-slide-toggle-used', 'true')


        console.dir(this.target)
        setTimeout(() => {
            setTimeout(() => {
                this.target.style.overflow = 'auto'
            }, this.animationDurationMs)
        }, this.delay)
    }

    close () {
        this.target.style.height = `${this.target.offsetHeight}px`
        this.el.setAttribute('data-slide-toggle-used', 'false')

        setTimeout(() => {
            this.target.style.height = 0
        }, this.delay)

        setTimeout(() => {
            this.target.style.height = 'auto'
            this.target.style.display = 'none'
        }, this.animationDurationMs + this.delay)
    }
}
